<template>
  <v-app>
    <v-app-bar app flat color="primary" dark clipped-left height="75">
      <v-app-bar-nav-icon
        @click.stop="showNavigation = !showNavigation"
        class="d-flex d-md-none"
      ></v-app-bar-nav-icon>
      <div class="pl-sm-12 d-flex align-center">
        <SvgIcon icon="cp-logo-1" height="60px" fill="white"></SvgIcon>
      </div>
      <v-spacer></v-spacer>
      <PractitionerLoggedToolbarBox></PractitionerLoggedToolbarBox>
      <v-btn icon @click="notificationDrawer = true" class="mr-2">
        <v-icon>notifications</v-icon>
      </v-btn>

      <v-btn
        @click="dialogWelcome = true"
        outlined
        rounded
        class="mr-md-12 d-none d-md-flex"
      >
        <span class="caption">Ayuda</span>
      </v-btn>
      <v-dialog v-model="dialogWelcome" width="320">
        <v-card>
          <PractitionerWelcomeSlide
            v-on:done="dialogWelcome = false"
            v-if="dialogWelcome"
          ></PractitionerWelcomeSlide>
        </v-card>
      </v-dialog>
    </v-app-bar>

    <v-navigation-drawer
      left
      app
      v-model="showNavigation"
      mobile-break-point="960"
      class="secondary"
      dark
      touchless
      clipped
    >
      <v-list nav rounded class="mt-2 mt-sm-4">
        <template v-for="(item, i) in views">
          <v-list-item-group
            v-if="item.route"
            :key="i"
            color="white"
            active-class="white--text"
          >
            <v-list-item :to="item.route">
              <v-list-item-avatar horizontal class="pl-4 pr-0">
                <SvgIcon :icon="item.icon" fill="white" height="24px" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  v-text="item.name"
                  class="body-1 font-weight-bold"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>

          <div v-else :key="i">
            <v-list-item :prepend-icon="item.icon">
              <v-list-item-avatar horizontal class="pl-4 pr-0">
                <SvgIcon :icon="item.icon" fill="white" height="24px" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  v-text="item.name"
                  class="body-1 font-weight-bold"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-for="subItem in item.modules"
              :key="subItem.name"
              :to="subItem.route"
              two-line
              class="pl-12"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-text="subItem.name"
                  class="body-1 font-weight-bold"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
      </v-list>

      <v-list class="pl-4">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Contáctanos</v-list-item-title>
            <v-list-item-subtitle>
              <a
                class="white--text font-weight-bold"
                href="mailto:contacto@costapez.org?subject=Consulta%20CostaPez"
                >contacto@costapez.org</a
              >
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-content app class="app-content" :class="dark ? '' : 'grey lighten-5'">
      <transition-page>
        <router-view />
      </transition-page>
    </v-content>

    <v-footer
      class="primary darken-2 d-flex justify-center"
      height="120"
      :inset="false"
      app
      absolute
    >
      <div>
        <SvgIcon icon="cp-logo-2" height="50px" fill="white"></SvgIcon>
      </div>
    </v-footer>

    <v-navigation-drawer
      v-model="notificationDrawer"
      right
      temporary
      app
      color="secondary"
      dark
      class="notificationDrawer"
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title font-weight-bold"
              >Notificaciones</v-list-item-title
            >
            <v-list-item-subtitle></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <p
          v-if="!notificationList.length"
          class="text-center font-weight-medium"
        >
          No tienes notificaciones
        </p>
        <template v-for="(item, i) in notificationList">
          <v-list-item :key="item" :to="'/costa-pez/administrador/especies'">
            <v-list-item-avatar>
              <v-icon
                v-text="item.icon || 'info'"
                class="pink white--text"
              ></v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title style="white-space: pre-line;">{{
                item.text
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                item.createdAtLegible
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="i"></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>
    <PwaRefresh></PwaRefresh>
  </v-app>
</template>

<script>
import views from "@/views";
import viewsAdmin from "@/viewsAdmin";
import PractitionerWelcomeSlide from "@/components/Practitioner/PractitionerWelcomeSlide";
import TransitionPage from "@/components/TransitionPage";
import PractitionerLoggedToolbarBox from "@/components/Practitioner/PractitionerLoggedToolbarBox";
import SvgIcon from "@/components/SvgIcon";
import PwaRefresh from "@/components/PwaRefresh";

export default {
  components: {
    PractitionerWelcomeSlide,
    PractitionerLoggedToolbarBox,
    TransitionPage,
    PwaRefresh,
    SvgIcon
  },
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    },
    dark() {
      return this.$vuetify.theme.dark;
    }
  },
  data: () => ({
    notificationDrawer: false,
    notificationList: [],
    views: [],
    allViews: views,
    dialogWelcome: false,
    showNavigation: null
  }),
  watch: {
    notificationDrawer() {
      if (this.notificationDrawer) {
        this.getNotificationList();
      }
    }
  },
  methods: {
    validateTheme() {
      let { darkMode, color } = this.practitionerLogged;
      this.$vuetify.theme.dark = !!darkMode;
      if (color) {
        this.$vuetify.theme.themes.light.primary = color;
        this.$vuetify.theme.themes.dark.primary = color;
      }
    },
    validateViews() {
      this.views = this.practitionerLogged.hasAdminAccess
        ? [...views, ...viewsAdmin]
        : views;
    },
    onNotificationClick: function() {},
    async getNotificationList() {
      try {
        let { data: notificationList } = await this.$http.get("notification", {
          params: {
            where: {
              practitioner: this.practitionerLogged.id
            },
            sort: "createdAt DESC",
            limit: 10
          }
        });
        this.notificationList = notificationList;
      } catch (err) {}
    }
  },
  mounted() {
    this.getNotificationList();
    this.validateViews();
  }
};
</script>

<style>
.logo {
  width: 8.17em;
  height: 8em;
}

.v-navigation-drawer {
  max-height: 100vh !important;
  z-index: 99 !important;
}
.v-footer {
  z-index: 101 !important;
}
.notificationDrawer {
  z-index: 100 !important;
}

fieldset {
  border-color: var(--v-secondary-base) !important;
}
label {
  color: var(--v-secondary-base) !important;
}
.v-text-field__suffix {
  color: var(--v-secondary-base) !important;
}
input {
  color: var(--v-secondary-base) !important;
}
::placeholder {
  color: var(--v-secondary-base) !important;
}
.v-input__icon--prepend-inner i {
  color: var(--v-secondary-base) !important;
}

.v-text-field__prefix {
  color: var(--v-secondary-base) !important;
}

.v-text-field__suffix {
  color: var(--v-secondary-base) !important;
}

.v-input__append-inner button {
  color: var(--v-secondary-base) !important;
}
</style>
